import React, { FC } from 'react';

export const IconLogo: FC<{}> = () => {
   return (
      <svg
         id="Capa_1"
         height="512"
         viewBox="0 0 495.74 495.74"
         width="512"
         xmlns="http://www.w3.org/2000/svg"
         className="zoomIn"
      >
         <g>
            <g id="XMLID_233_">
               <g>
                  <path
                     d="m252.291 290.264-46.88-3.034-95.8 82.12 80.12 105.34 100.25-90.22 13.269-32.673z"
                     fill="#01d0fb"
                  />
                  <path
                     d="m298.116 247.87-36.715-8.63-55.99 47.99 84.57 97.24 56.69-51.02 4.76-26.628z"
                     fill="#62dbfb"
                  />
                  <path
                     d="m365.007 191.464-45.746-1.824-57.86 49.6 85.27 94.21 56.91-51.22 15.76-31.702z"
                     fill="#99e6fc"
                  />
                  <path
                     d="m435.851 204.26c13.44 14.86 12.28 37.81-2.58 51.26l-29.69 26.71-84.32-92.59 59.42-50.93 25.66 30.71z"
                     fill="#c8effe"
                  />
               </g>
            </g>
         </g>
         <path
            d="m214.249 239.321-48.198 16.559-93.9 151.27 130.76 53.52 85.85-124.13 4.797-46.276z"
            fill="#05e39c"
         />
         <g>
            <g id="XMLID_199_">
               <g>
                  <path
                     d="m265.928 174.686-55.107 9.064-44.77 72.13 122.71 80.66 45.67-66.04 5.688-44.994z"
                     fill="#00f2a6"
                  />
                  <path
                     d="m379.006 167.3-85.448-54.872-41.267 4.502-41.47 66.82 123.61 86.75 47.1-68.11z"
                     fill="#6cf5c2"
                  />
                  <path
                     d="m396.741 116.61c16.48 11.4 20.6 34 9.2 50.49l-24.41 35.29-129.24-85.46 41.82-67.37 59.18 37z"
                     fill="#9cf8d2"
                  />
               </g>
            </g>
         </g>
         <g id="XMLID_134_">
            <path
               d="m123.743 213.827-67.046 166.078c-17.306 42.869 3.413 91.641 46.281 108.947 42.859 17.302 91.641-3.413 108.947-46.281l66.295-164.219z"
               fill="#fed402"
            />
            <g id="XMLID_186_">
               <g>
                  <path
                     d="m301.475 197.953-114.081-53.375-33.984 10.279-33.43 80.57 151.733 59.044 31.537-78.234z"
                     fill="#fee45a"
                  />
                  <path
                     d="m331.756 107-121.433-38.93-25.219 11.45-31.3 75.46 149.499 61.24 31.801-78.78z"
                     fill="#fee97d"
                  />
                  <path
                     d="m332.217 46.688c18.62 7.43 27.69 28.54 20.27 47.16l-17.38 43.59-150-57.92 27.17-65.49c9.34-5.49 21.02-6.78 31.87-2.45z"
                     fill="#fef0ae"
                  />
               </g>
            </g>
            <g>
               <path
                  d="m50.521 336.43v-84.57-84.56-84.57-46.44c0-20.05 16.25-36.29 36.29-36.29h94.81c20.05 0 36.3 16.24 36.3 36.29v375.75c0 46.23-37.48 83.7-83.7 83.7-46.23 0-83.7-37.47-83.7-83.7z"
                  fill="#f9f7f8"
               />
            </g>
            <g>
               <g id="XMLID_173_">
                  <g>
                     <path
                        d="m217.921 36.29v46.44l-85.847 8-81.553-8v-46.44c0-20.05 16.25-36.29 36.29-36.29h94.81c20.05 0 36.3 16.24 36.3 36.29z"
                        fill="#f9b1b1"
                     />
                     <path
                        d="m217.921 82.73v84.57l-84.748 10-82.652-10v-84.57z"
                        fill="#f79595"
                     />
                     <path
                        d="m217.921 251.86v84.57h-167.4v-84.57l81.553-10z"
                        fill="#ee6161"
                     />
                     <path
                        d="m50.521 167.3h167.4v84.56h-167.4z"
                        fill="#f47c7c"
                     />
                  </g>
               </g>
            </g>
         </g>
         <circle cx="132.518" cy="412.319" fill="#e5e1e5" r="28.466" />
      </svg>
   );
};
